<template>
  <v-container>
         <h1>{{ $t('ParticipantDocument.headline') }}</h1>

        <div style="height: 66vh">
          <Pdf v-if="participantDocument && participantDocument" :pdf-url="participantDocument" />
          <div v-else>{{ $t('ParticipantDocument.noDocument') }}</div>
        </div>

  </v-container>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import Pdf from './Pdf.vue';

export default {
  name: 'CandidateDocument',
  components: {
    Pdf,
  },
  data: () => ({
    editor: null,
    penInk: '',
    observationData: null,
    currentObservation: {},
  }),
  computed: {
    ...mapGetters(['currentParticipant']),
    ...mapState({
      user: (state) => state.user,
      runInfo: (state) => state.runInfo,
      currentParticipantId: (state) => state.currentParticipantId,
      participantDocument: (state) => {
        const participant = state.runInfo.participants.find((c) => c.id === state.currentParticipantId);
        return participant.documentUrl
      }
    }),
  },
  methods: {
  },
  mounted() {

  },
  beforeDestroy() {

  },
};
</script>
